import React, { useState, useCallback } from "react";
import styles from "./DealerReporting.module.scss";
import { Grid } from "@mui/material";
import Item from "../../../../shared/item/Item";
import SortingIcon from "../../../../shared/sortingIcon/SortingIcon";
import SortData from "../../../../utils/SortUtil";
import { withTranslation } from "react-i18next";
import DownloadButtonV2 from "../../../../shared/buttons/DownloadButtonV2";
import { fileDownload } from "../../../../utils/FileDownloadUtil";
import { logMsg } from "../../../../common/Logger";
import DealerReportingClient from "../../../../shared/clients/DealerReportingClient";
import { IS_CANADA_MARKET, IS_USA_MARKET } from "../../../../utils/EmpUtil";

function DealerReporting(props) {
  const [sortKey, setSortKey] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const downloadOrderStatusReport = useCallback((report) => {
    DealerReportingClient.downloadDealerReservationReport(
      props.user,
      props.lang
    )
      .then((res) => {
        const filename = props.t(report.description) + ".csv";
        const BOM = "\uFEFF";
        const response = BOM + res;
        fileDownload(
          decodeURIComponent(response),
          "text/csv;charset=utf-8;",
          filename
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      });
  }, [props.user, props.lang, props.t]);

  const [reports, setReports] = useState([
    {
      key: "report1",
      name: props.t("dealerReporting.report1Name"),
      description: props.t("dealerReporting.report1Description"),
      condition: !(
        IS_USA_MARKET(props.user.market) ||
        IS_CANADA_MARKET(props.user.market)
      ),
      downloadLink: downloadOrderStatusReport,
    },
  ]);

  const sortColumns = useCallback((sortByCol) => {
    let sortDir = "DSC";
    if (sortByCol === sortKey) {
      sortDir = sortDirection === "ASC" ? "DSC" : "ASC";
    }

    SortData(
      sortByCol,
      sortDir,
      "alphanumeric",
      reports,
      function (sortedData) {
        setSortDirection(sortDir);
        setSortKey(sortByCol);
        setReports(sortedData);
      }
    );
  }, [sortKey, sortDirection, reports]);

  return (
    <>
      <Grid container className={`pagePadding ${styles.gridHeader}`}>
        <Grid
          item
          md={3}
          className={styles.typeHeader}
          onClick={() => sortColumns("name")}
        >
          <Item value={props.t("dealerReporting.type")} />
          <span className={styles.sorting}>
            <SortingIcon
              currentKey="name"
              sortKey={sortKey}
              sortDirection={sortDirection}
            />
          </span>
        </Grid>
        <Grid
          item
          md={7}
          className={styles.typeHeader}
          onClick={() => sortColumns("description")}
        >
          <Item value={props.t("dealerReporting.document")} />
          <span className={styles.sorting}>
            <SortingIcon
              currentKey="description"
              sortKey={sortKey}
              sortDirection={sortDirection}
            />
          </span>
        </Grid>
        <Grid item md={2} className={styles.actionHeader}>
          <Item value={props.t("dealerReporting.action")} />
        </Grid>
      </Grid>

      {reports.map(
        (report) =>
          report.condition && (
            <React.Fragment key={report.key}>
              <Grid
                container
                className={`pagePaddingLeft pagePaddingRight ${styles.gridBody}`}
              >
                <Grid item md={3} className={styles.colType}>
                  <div>{report.name}</div>
                </Grid>
                <Grid item md={7} className={styles.colDocument}>
                  <div>{report.description}</div>
                </Grid>
                <Grid item md={2} className={`${styles.end}`}>
                  <DownloadButtonV2
                    download={() => report.downloadLink(report)}
                    text={props.t("dealerReporting.download")}
                  />
                </Grid>
              </Grid>
            </React.Fragment>
          )
      )}
    </>
  );
}

export default withTranslation("emp")(DealerReporting);
